import React from "react";

const HisEyeOff = ({ color = "#708FBB", sx = {} }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg style={_sx} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0603 9.98438C9.76556 10.259 9.52915 10.5902 9.36518 10.9582C9.20121 11.3262 9.11304 11.7235 9.10594 12.1263C9.09883 12.5291 9.17293 12.9292 9.32381 13.3028C9.4747 13.6763 9.69927 14.0157 9.98415 14.3005C10.269 14.5854 10.6084 14.81 10.9819 14.9609C11.3555 15.1118 11.7556 15.1858 12.1584 15.1787C12.5612 15.1716 12.9585 15.0835 13.3265 14.9195C13.6945 14.7555 14.0257 14.5191 14.3003 14.2244"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9102 5.18156C11.3315 5.12907 11.7556 5.10236 12.1802 5.10156C19.1802 5.10156 22.1802 12.1016 22.1802 12.1016C21.7331 13.0587 21.1724 13.9585 20.5102 14.7816"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.78969 6.71094C4.80094 8.06556 3.20956 9.9262 2.17969 12.1009C2.17969 12.1009 5.17969 19.1009 12.1797 19.1009C14.0956 19.1061 15.9705 18.546 17.5697 17.4909"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.17969 2.10156L22.1797 22.1016"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisEyeOff;
